import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Shared report header component for all reports
 * Provides consistent styling and includes logos, report title, date, and source file
 */
const ReportHeader = ({ 
  title, 
  logos = {}, 
  fileName = null,
  subtitle = null,
  sectionId = 'report-header-section'
}) => {
  return (
    <Box 
      data-section={sectionId}
      sx={{ 
        bgcolor: 'white', 
        p: 3, 
        borderBottom: '3px solid #000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {logos?.clientLogo && (
          <img 
            src={logos.clientLogo} 
            alt="Client Logo" 
            style={{ height: '60px', maxWidth: '120px', objectFit: 'contain' }} 
          />
        )}
      </Box>
      
      <Box sx={{ textAlign: 'center', flex: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#000', mb: 1 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
            {subtitle}
          </Typography>
        )}
        <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
          Generated: {new Date().toLocaleDateString()}
        </Typography>
        {fileName && (
          <Typography variant="body1" sx={{ color: '#888', fontStyle: 'italic' }}>
            Source File: {fileName}
          </Typography>
        )}
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mr: 2 }}>
        {logos?.companyLogo && (
          <img 
            src={logos.companyLogo} 
            alt="Company Logo" 
            style={{ height: '60px', maxWidth: '120px', objectFit: 'contain' }} 
          />
        )}
      </Box>
    </Box>
  );
};

export default ReportHeader;